import { ConfirmActionModal } from "../../../../components/common/Modal/ConfirmActionModal";
import { showSuccessToast } from "../../../../components/PluginsMenu/Toastr/Toastr";
import { GenericTable } from "../../../../components/Sessions/GenericTable";
import DeleteIcon from "../../../../../svg/DeleteIcon";
import KeyIcon from "../../../../../svg/KeyIcon";
import { EditRoleModal } from './EditRoleModal';
import React, { useEffect, useState } from "react";
import { CreateAdminModal } from "./CreateAdminModal";
import useIsSuperAdmin from "../../../../../hooks/useIsSuperAdmin";
import { useGetAllAdminsQuery } from "../../../../../store/services/admin/UserService";

const mockData = [
  { id: 1, name: "Muhammad Okamis", username: "okamis", email: "okamis63@gmail.com", role: "Data Entry" },
  { id: 2, name: "Muhammad Ali Sethi", username: "ali", email: "ali@nkenneapp.com", role: "Administrator" },
  { id: 3, name: "Olalekan Adebayo", username: "olalekana142@gmail.com", email: "olalekana142@gmail.com", role: "Data Entry" },
  { id: 4, name: "Umar Shahbaz", username: "umar", email: "umar.sh2622@gmail.com", role: "Administrator" },
  { id: 5, name: "Administrator", username: "admin", email: "admin@gmail.com", role: "Administrator" },
];

const roles = [
  { id: 1, name: 'User Management', memberCount: 1 },
  { id: 2, name: 'Data Entry', memberCount: 2 },
  { id: 3, name: 'Content Manager', memberCount: 0 },
  { id: 4, name: 'Finance Manager', memberCount: 0 },
  { id: 5, name: 'Administrator', memberCount: 2 }
];

export const AdminAdminsListing = () => {
  
  
  const isSuperAdmin = useIsSuperAdmin();
  
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCreateAdminModal, setShowCreateAdminModal] = useState(false);
  const [selectedAdminId, setSelectedAdminId] = useState(null);
  const [showEditRoleModal, setShowEditRoleModal] = useState(false);
  const [selectedAdminForRoleEdit, setSelectedAdminForRoleEdit] = useState(null);

  const { data, isLoading, error } = useGetAllAdminsQuery();
  const [admins, setAdmins] = useState([]);
  
  useEffect(() => {
    if (data) {
      setAdmins(data.data?.adminList);
    }
  }, [data]);
  
  if (isLoading) {
    return <p>Loading admins...</p>;
  }

  const confirmDeleteAdmin = () => {
    showSuccessToast(`Admin deleted with ID ${selectedAdminId}`);
    setAdmins((prevAdmins) => prevAdmins.filter((admin) => admin.id !== selectedAdminId));
    setShowDeleteModal(false);
  };

  const handleAdminDeleteClick = (event, id) => {
    event.stopPropagation();
    setSelectedAdminId(id);
    setShowDeleteModal(true);
  };

  const handleRoleChange = (id, newRole) => {
    setAdmins((prevAdmins) => prevAdmins.map((admin) => {
      if (admin.id === id) {
        return { ...admin, role: newRole };
      }
      return admin;
    }));
  };

  const handleEditRoleClick = (event, admin) => {
    event.stopPropagation();
    setSelectedAdminForRoleEdit(admin);
    setShowEditRoleModal(true);
  };

  const handleAddAdminClick = () => {
    setShowCreateAdminModal(true);
  };

  const handleCreateAdmin = (newAdminData) => {
    const newAdmin = {
      id: admins.length + 1,
      name: `${newAdminData.firstName} ${newAdminData.lastName}`,
      username: newAdminData.email.split('@')[0],
      email: newAdminData.email,
      role: newAdminData.role
    };

    setAdmins(prevAdmins => [...prevAdmins, newAdmin]);

    showSuccessToast(`Admin ${newAdmin.name} created successfully`);

    setShowCreateAdminModal(false);
  };

  const buttonConfig = [
    ...(isSuperAdmin ? [{
      label: "Create Admin",
      variant: "primary",
      onClick: handleAddAdminClick,
    }] : [])
  ];

  const Actions = ({ id, admin }) => (
    <div className="d-flex gap-2">
      <div onClick={(e) => handleEditRoleClick(e, admin)}>
        <KeyIcon width={18} height={18} />
      </div>
      <div onClick={(e) => handleAdminDeleteClick(e, id)}>
        <DeleteIcon fill="#ff0000" width={18} height={18} />
      </div>
    </div>
  );

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Username", accessor: "userName" },
    { header: "Email", accessor: "email" },
    { header: "Role", accessor: "roleName" },
    ...(isSuperAdmin ? [{
      header: 'Actions',
      accessor: 'actions',
      render: (item) => <Actions id={item.id} admin={item} />,
    }] : [])
  ];

  const searchableColumns = [
    "userName",
    "email",
    "name"
  ]

  return (
    <>
      <GenericTable
        columns={columns}
        data={admins}
        buttonConfig={buttonConfig}
        searchableColumns={searchableColumns}
      />

      {/* Confirmation Modal for Deletion */}
      <ConfirmActionModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDeleteAdmin}
        title="Delete Admin"
        message="Are you sure you want to delete this admin? This action cannot be undone."
        confirmText="Delete"
      />

      {/* Create Admin Modal */}
      <CreateAdminModal
        show={showCreateAdminModal}
        handleClose={() => setShowCreateAdminModal(false)}
        onCreateAdmin={handleCreateAdmin}
      />

      {/* Edit Role Modal */}
      <EditRoleModal
        show={showEditRoleModal}
        handleClose={() => setShowEditRoleModal(false)}
        selectedAdmin={selectedAdminForRoleEdit}
        roles={roles}
        handleRoleChange={handleRoleChange}
      />
    </>
  );
};